export default __webpack_public_path__ + "static/transforming-printing-with-enterprise-platform-557cbed8436d3808be4d0e1a27830817.jpg";